<script lang="ts">
	import { format } from 'svelte-i18n';
	// Stores
	import { devicesFiltersInitialState } from 'src/stores/ui/filters';
	import type { FilterOption } from 'src/stores/ui/filters';
	// Design system components
	import { Token } from '@Shelly/shelly-design-system';
	import { deepCopy } from 'src/helpers/utilities';

	export let appliedFilters;
	export let toggleFilterOptions;

	let filterOptions: FilterOption[] = [
		{
			id: 'cloudEnabled',
			title: $format('cloud_online', {
				default: 'Cloud online',
			}),
			translationDefault: 'Cloud online',
			selected: false,
		},
		{
			id: 'cloudDisabled',
			title: $format('cloud_offline', {
				default: 'Cloud offline',
			}),
			translationDefault: 'Cloud offline',
			selected: false,
		},
	].map((option) => {
		const storeOption = appliedFilters.cloud_connectivity.find((filter) => filter.id === option.id);
		option.selected = storeOption.selected;
		return option;
	});

	const handleSelectFilter = (option) => {
		appliedFilters.cloud_connectivity = appliedFilters.cloud_connectivity.map((filter) => {
			if (filter.id === option.id) {
				filter.selected = !filter.selected;
				return filter;
			}
			return filter;
		});

		filterOptions = toggleFilterOptions(filterOptions, option);
	};

	const resetData = () => {
		appliedFilters.cloud_connectivity = deepCopy(devicesFiltersInitialState.cloud_connectivity);

		filterOptions = filterOptions.map((filter) => {
			return {
				...filter,
				selected: false,
			};
		});
	};
</script>

<svelte:window on:reset={resetData} />

<div class="d-flex flex-wrap" style="gap: 8px;">
	{#each filterOptions as option}
		<Token
			id="token-qerwct9"
			size="m"
			title={option.title}
			on:click={() => handleSelectFilter(option)}
			selected={option.selected}
		/>
	{/each}
</div>
